import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import React from "react";
var __jsx = React.createElement;
import classNames from "classnames";
import { t } from "i18next";
import { hasSiteKeyword } from "../utils";
import { trackEvent } from "../utils/mixpanel";
import { MIXPANEL_EVENTS } from "../utils/mixpanelEvents";
import SourceDropdown from "./SourceDropdown";
function SelectWorkspace(props) {
  var siteOptions = props.siteOptions,
    setSelectedSource = props.setSelectedSource,
    selectedSource = props.selectedSource,
    _props$className = props.className,
    className = _props$className === void 0 ? "" : _props$className,
    disabled = props.disabled;
  var _hasSiteKeyword = hasSiteKeyword();
  return /*#__PURE__*/React.createElement("div", {
    className: classNames("z-40", _defineProperty({}, className, !!className))
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex relative items-center border justify-between space-x-12 border-gray-300 dark:border-gray-600 rounded-lg text-base px-5 py-2 bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-100"
  }, /*#__PURE__*/React.createElement("p", {
    className: "whitespace-nowrap"
  }, t(_hasSiteKeyword ? "site_key" : "workspace_key"), ":"), /*#__PURE__*/React.createElement("div", {
    className: "w-full"
  }, /*#__PURE__*/React.createElement(SourceDropdown, {
    options: siteOptions,
    onChange: function onChange(option) {
      setSelectedSource(option);
      trackEvent(MIXPANEL_EVENTS.WORKSPACE_SELECTED, {
        value: option
      });
    },
    onOpen: function onOpen() {
      return trackEvent(MIXPANEL_EVENTS.WORKSPACE_DROPDOWN_OPENED);
    },
    selectedOption: selectedSource,
    className: "w-full",
    optionClassName: "w-full",
    isBottomAligned: true,
    disabled: disabled,
    isWorkspace: true
  }))));
}
export default SelectWorkspace;